import React from 'react';
import { View } from 'react-native';

import { map as _map } from 'lodash';
import PropTypes from 'prop-types';

import { Shimmer } from '@vfgroup-oneplatform/foundation/Components';
import { shimmerPlaceholderConfig } from '@vfgroup-oneplatform/foundation/Components/Shimmer/Shimmer.utils';

import {
  headerLoadingConfig,
  squareLoadingConfig,
  titleLoadingConfig,
  footerLoadingConfig,
  showMoreLoadingConfig,
} from './DevicesLoading.Config';
import styles from './DevicesLoading.Styles';

function DevicesLoading({ theme }) {
  const renderCard = key => (
    <View style={styles.cardContainerStyle(theme)} key={key}>
      <View style={styles.cardContent}>
        <View style={styles.squareContianer}>
          <Shimmer
            config={squareLoadingConfig}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          />
        </View>
        <View style={styles.titleContainer}>
          {_map(Array(key === 0 ? 3 : 4), (_, index) => (
            <Shimmer
              config={titleLoadingConfig(index === 0)}
              shimmerPlaceholderConfig={shimmerPlaceholderConfig}
            />
          ))}
        </View>
      </View>
      {key !== 0 && (
        <View>
          <Shimmer
            config={footerLoadingConfig}
            shimmerPlaceholderConfig={shimmerPlaceholderConfig}
          />
        </View>
      )}
    </View>
  );

  const renderHeader = () => (
    <View style={styles.headerContainer}>
      <Shimmer config={headerLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
    </View>
  );

  const renderShowMore = () => (
    <View style={styles.showMoreContainer}>
      <Shimmer config={showMoreLoadingConfig} shimmerPlaceholderConfig={shimmerPlaceholderConfig} />
    </View>
  );

  return (
    <View style={styles.containerStyle}>
      {renderHeader()}
      {_map(Array(3), (_, key) => renderCard(key))}
      {renderShowMore()}
    </View>
  );
}

DevicesLoading.propTypes = {
  theme: PropTypes.object,
};

export default DevicesLoading;
